import { useTranslation } from 'react-i18next';

const PageAlertMobile = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-start self-stretch h-full p-16 pb-0">
      <section className="flex flex-col justify-center items-center grow self-stretch pt-[40px] pb-[80px] gap-[60px]">
        <div className="flex w-[144px] h-[48px] flex-col items-start gap-[8px] aspect-[3/1]">
          <img
            src="/assets/logo/new_logo_fitta.png"
            alt="Fitta Empowered by Là Nhà"
          />
        </div>
        <div className="flex flex-col items-center justify-center gap-[16px] self-stretch">
          <span className="text-label-large text-center text-black">
            {t('The mobile version of Fitta is not ready yet.')}
          </span>
          <span className="text-label-large text-center text-black">
            {t('Please access on a computer for the best experience.')}
          </span>
        </div>
      </section>
    </div>
  );
};

export default PageAlertMobile;
